import type * as React from 'react';
import type { DataView as LocalDataView } from '@verclam/ui-kit';
import { theme } from '@Guidelines/Theme/theme';
import { css as toClassName } from '@emotion/css';

export const fieldWithoutMarginStyles = {
	root: {
		style: {
			margin: '0.5rem 0',
		},
	},
	subRoot: {
		style: {
			alignItems: 'center',
		},
	},
};

// Dataview Grid

const cardsGridStyle = toClassName`
	display: grid;
	grid-template-columns: 1fr;
	gap: 0.875rem;
	margin-bottom: 0.875rem;

	@media (max-width: ${theme.layout.compactBreakpoint}) {
		grid-template-columns: 1fr;
	}
`;

export const dataViewGridPt: React.ComponentProps<typeof LocalDataView>['pt'] = {
	root: {
		style: {
			height: '100%',
			display: 'flex',
			flexDirection: 'column',
			gap: '1rem',
		},
	},
	grid: { className: cardsGridStyle },
	content: {
		style: {
			flex: 1,
		},
	},
	emptyMessage: {
		style: {
			height: '100%',
		},
	},
};
